import { useIsMobile } from '@base/hooks/use-mobile';
import classNames from 'classnames';
import React from 'react';

import { setupForDark } from '@theme';

function PlaceholderIcon({
  children,
  size = 166,
  mobileSize = undefined,
  heightScale = 1,
  viewbox = '0 0 166 166'
}: {
  children: React.ReactNode;
  size?: number;
  mobileSize?: number;
  heightScale?: number;
  viewbox?: string;
}) {
  const _mobileSize = mobileSize ?? Math.ceil(0.8 * size);
  const isMobile = useIsMobile();
  return (
    <span className={classNames('flex items-center', setupForDark('text-label-primary'))}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={isMobile ? _mobileSize : size}
        height={Math.ceil(isMobile ? _mobileSize : size * heightScale)}
        viewBox={viewbox}
        fill='currentColor'
      >
        {children}
      </svg>
    </span>
  );
}

export default PlaceholderIcon;
